import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePatch, handleDateChangeEvent } from '../../../../utils/AxiosUtil';
import { toDateFormat } from '../../../../utils/Util';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareNumberField from '../../../common/inputfields/ErrorAwareNumberField';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import MyMultiSelectAutocomplete from '../../../common/inputfields/MyMultiSelectAutocomplete';
import * as util from './ProjectUtil';

function getInitialCustomers(customers) {
    const result = [];
    customers.map(customer => {
        result.push({ value: customer.privateId, label: customer.name });
        return null;
    })
    return result;
}

class ModifyProject extends Component {
    componentDidMount() {
        console.log(this.props)
    }

    state = {
        selectedCustomers: getInitialCustomers(this.props.row.customers),
        prevCustomers: getInitialCustomers(this.props.row.customers),
        publicId: this.props.row.publicId,
        location: this.props.row.location,
        paymentCommitmentInDays: this.props.row.paymentCommitmentInDays,
        startDate: new Date(this.props.row.startDate),
        endDate: this.props.row.endDate ? new Date(this.props.row.endDate) : null,
        errors: new Map(),
        comment: this.props.row.comment,
        shortName: this.props.row.shortName,
    };

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/project';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "customerIds": util.getCustomers(this.state.selectedCustomers),
            "publicId": this.state.publicId,
            "location": this.state.location,
            "paymentCommitmentInDays": this.state.paymentCommitmentInDays,
            "startDate": toDateFormat(this.state.startDate),
            "endDate": toDateFormat(this.state.endDate),
            "comment": this.state.comment,
            "shortName": this.state.shortName
        };
        await handlePatch(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyMultiSelectAutocomplete
                            value={this.state.selectedCustomers}
                            prevValue={this.state.prevCustomers}
                            getOptions={util.promiseCustomerOptions}
                            onChange={(e, v) => util.handleCustomerSelected(e, v, this)}
                            label={'Vevő'}
                            createLabel={'Új vevő'}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            required
                            name="publicId"
                            label="Munkaszám"
                            value={this.state.publicId}
                            prevValue={this.props.row.publicId}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="location"
                            label="Helyszín"
                            value={this.state.location}
                            prevValue={this.props.row.location}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="shortName"
                            label="Rövid név"
                            value={this.state.shortName}
                            prevValue={this.props.row.shortName}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            required
                            name="paymentCommitmentInDays"
                            label="Fizetési határidő(napok száma)"
                            value={this.state.paymentCommitmentInDays}
                            prevValue={this.props.row.paymentCommitmentInDays}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            name="startDate"
                            label="Project kezdés"
                            errors={this.state.errors}
                            value={this.state.startDate}
                            prevValue={this.props.row.startDate}
                            onChange={e => handleDateChangeEvent(e, "startDate", this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            name="endDate"
                            label="Project vége"
                            errors={this.state.errors}
                            value={this.state.endDate}
                            prevValue={this.props.row.endDate}
                            onChange={e => handleDateChangeEvent(e, "endDate", this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            value={this.state.comment}
                            prevValue={this.props.row.comment}
                            modify={true}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Módosít
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyProject);

